import axios from "axios";

export interface CloudinaryUploadResult {
  secure_url: string;
  public_id: string;
  original_filename: string;
  bytes: number;
  resource_type: string;
  format: string;
}

export const uploadFileToCloudinary = async (
  file: File,
  folder: string = "cms/projects"
): Promise<CloudinaryUploadResult | null> => {
  const UPLOAD_PRESET = process.env.REACT_APP_UPLOAD_PRESET || "";
  const CLOUDINARY_URL = `${process.env.REACT_APP_API_CLOUDNIRY_URL}/${process.env.REACT_APP_CLOUD_NAME}/upload`;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);
  formData.append("folder", folder);

  try {
    const response = await axios.post(CLOUDINARY_URL, formData);
    return response.data as CloudinaryUploadResult;
  } catch (error) {
    return null;
  }
};
